import map from 'lodash/map';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import Chart from '../../../../../../../node_modules/chart.js/src/chart';
import {
  fetchStatsIfNeeded,
  refreshStats,
} from '../../../../../../actions/app/other/mpp/users';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../../components/Loader';
import selectEntities from '../../../../../../selectors/entities';
import './index.css';

let chart;

class MPPRegistrationsWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start};
  }

  fetchStats() {
    const {end, start} = this.state;
    this.props.dispatch(fetchStatsIfNeeded({end, start}));
  }

  refreshStats() {
    const {end, start} = this.state;
    this.props.dispatch(refreshStats({end, start}));
  }

  componentDidMount() {
    this.fetchStats();

    const ctx = document.getElementById('newMembersChart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                time: {
                  unit: 'day',
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.widget.ids !== this.props.widget.ids) {
      const {entities} = nextProps.statistics;

      const datasets = [
        {
          label: 'MPP FR',
          backgroundColor: '#39796b',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPP EN',
          backgroundColor: '#a98274',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPP ES',
          backgroundColor: '#dd9189',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPP OTHER',
          backgroundColor: 'brown',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
      ];

      map(entities, stat => {
        datasets[0].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mppFr, 10),
        });
        datasets[1].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mppEn, 10),
        });
        datasets[2].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mppEs, 10),
        });
        datasets[3].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mppOther, 10),
        });
      });

      chart.data.datasets = datasets;
      chart.update();
    }
  }

  render() {
    const {end, start} = this.state;
    const {info} = this.props.widget;
    let {entities, total} = this.props.statistics;

    let sum = {
      mppFr: 0,
      mppEn: 0,
      mppEs: 0,
      mppOther: 0,
    };
    // eslint-disable-next-line
    entities.forEach(stat => {
      sum.mppFr += stat.mppFr || 0;
      sum.mppEn += stat.mppEn || 0;
      sum.mppEs += stat.mppEs || 0;
      sum.mppOther += stat.mppOther || 0;

      return {data: stat.data, amount: sum};
    });

    return (
      <div id="registrations-widget" className="row">
        <div className="col-md-12">
          <div className="box">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-user-plus" /> Registrations / New members
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  onClick={() => this.refreshStats()}>
                  <i className="fa fa-refresh" />
                </button>
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body">
              <div className="text-center margin-bottom">
                Users from
                <div className="inline data-range-picker">
                  <DateRangePickerWrapper
                    initialStartDate={moment(start)}
                    initialEndDate={moment(end)}
                    isOutsideRange={day => {
                      return (
                        moment(day).startOf('day').unix() >
                        moment().startOf('day').unix()
                      );
                    }}
                    onDatesChange={({startDate, endDate}) => {
                      this.setState({
                        start: moment(startDate).format('YYYY-MM-DD'),
                        end: moment(endDate).format('YYYY-MM-DD'),
                      });
                    }}
                  />
                  <button
                    className="btn btn-default"
                    onClick={() => this.refreshStats()}>
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="chart">
                    <canvas id="newMembersChart" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table-responsive table-fixed-height">
                    <table className="table table-bordered no-margin">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th className="text-center">MPP FR</th>
                          <th className="text-center">MPP EN</th>
                          <th className="text-center">MPP ES</th>
                          <th className="text-center">MPP OTHER</th>
                          <th className="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entities.map((stat, key) => (
                          <tr key={key} className="text-center">
                            <td className="text-left">
                              {moment(stat.date).format('LL')}
                            </td>
                            <td>{stat.mppFr}</td>
                            <td>{stat.mppEn}</td>
                            <td>{stat.mppEs}</td>
                            <td>{stat.mppOther}</td>
                            <td>
                              {numeral(
                                +parseInt(stat.mppFr, 10) +
                                  parseInt(stat.mppEn, 10) +
                                  parseInt(stat.mppEs, 10) +
                                  parseInt(stat.mppOther, 10),
                              ).format('0,0')}
                            </td>
                          </tr>
                        ))}
                        {entities.length > 0 && (
                          <tr key="all" className="text-center">
                            <td className="text-left">
                              Sum from {moment(start).format('LL')} to &nbsp;
                              {moment(end).format('LL')}
                            </td>
                            <td>{sum.mppFr}</td>
                            <td>{sum.mppEn}</td>
                            <td>{sum.mppEs}</td>
                            <td>{sum.mppOther}</td>
                            <td>
                              {numeral(
                                +parseInt(sum.mppFr, 10) +
                                  parseInt(sum.mppEn, 10) +
                                  parseInt(sum.mppEs, 10) +
                                  parseInt(sum.mppOther, 10),
                              ).format('0,0')}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {Boolean(total) && (
              <div className="box-footer">
                <div className="row">
                  <div className="col-xs-6 col-md-3">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mppFr, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-mppEs">
                        MPP FR
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mppEn, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-mpp">MPP EN</span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mppEs, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-mppEn">
                        MPP ES
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mppOther, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-mppEn">
                        MPP OTHER
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(
                          +parseInt(total.mppFr, 10) +
                            parseInt(total.mppEn, 10) +
                            parseInt(total.mppEs, 10) +
                            parseInt(total.mppOther, 10),
                        ).format('0,0')}
                      </h5>
                      <span className="description-text">Total</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics} = state.entities;
    const {userStats} = state.app.other.mpp;

    return {
      widget: userStats,
      statistics: {
        entities: selectEntities(statistics, userStats.ids),
        total: userStats.total,
      },
    };
  },
  dispatch => ({dispatch}),
)(MPPRegistrationsWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/components/Registrations/index.js